// extracted by mini-css-extract-plugin
export default {"cancelled":"SearchSponsorshipPage_cancelled__nBbY1"};